<script lang="ts" setup>
import type { EsProduct } from '~/types/elastic'

export interface Props {
  product: EsProduct
  label?: string
}
defineProps<Props>()
const { openFor } = useOfferFormDialog()
</script>

<template>
  <button
    v-if="product.isOffer"
    class="offer-button"
    @click="openFor(product)"
  >
    <span>{{ label || $t('Request a free quote') }}</span>
  </button>
</template>

<style src="~layers/app/components/Product/OfferButton.css" />
